import { ajax } from '@/util/ajax'
const BASE_URL = '/gateway/platform-lmsapi/payment'

const ProcessingApi = {
  getLoanDetailsBasic (input, success, failure) {
    ajax.get(
      `${BASE_URL}/loan-detail/fetch`,
      input,
      success,
      failure
    )
  },
  listLoanDetailsAdvance (input, success, failure) {
    ajax.post(
      `${BASE_URL}/advance/calculate`,
      input,
      success,
      failure
    )
  },
  getLoanHistoryByParentLoanId (input, success, failure) {
    ajax.get(
      `${BASE_URL}/slave-loan/list`,
      input,
      success,
      failure
    )
  },
  getLoanHistoryYoungestLoan (input, success, failure) {
    ajax.get(
        `${BASE_URL}/youngest-loan`,
        input,
        success,
        failure
    )
  },
  getPaymentFeeData (input, success, failure) {
    ajax.post(
      `${BASE_URL}/fee-data/fetch`,
      input,
      success,
      failure
    )
  },
  drawSubsequentAdvance (input, success, failure) {
    ajax.post(
      `${BASE_URL}/subsequent-advance/draw`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  multiOperation (input, success, failure) {
    ajax.post(
      `${BASE_URL}/multiple/operation`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  cancelOperation (input, success, failure) {
    ajax.post(
      `${BASE_URL}/cancel`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  listReturnCode (input, success, failure) {
    ajax.get(
      `${BASE_URL}/list/return-code`,
      input,
      success,
      failure
    )
  },
  move2Collection (input, success, failure) {
    ajax.post(
      `${BASE_URL}/manually/move-to-collection`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  previewEmailBySlaveLoan (input, success, failure) {
    ajax.post(
      `${BASE_URL}/slave-loan-agreement/preview`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  sendEmailForSlaveLoan (input, success, failure) {
    ajax.post(
      `${BASE_URL}/slave-loan-agreement/send`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  voidLoan (input, success, failure) {
    ajax.post(
      `${BASE_URL}/slave-loan/void`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  denySlaveLoan (input, success, failure) {
    ajax.post(
      `${BASE_URL}/slave-loan/deny`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  approveSlaveLoan (input, success, failure) {
    ajax.post(
      `${BASE_URL}/slave-loan/approve`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  addDebitCard (loanId, success, failure) {
    ajax.get(
      `${BASE_URL}/send-email/add-card`,
      { loanId: loanId },
      success,
      failure,
      { showLoading: true }
    )
  },
  cancelDetail (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/cancel/detail`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getPPSQueueCount (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/work-queue/queue-count`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getPPSQueueItem (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/work-queue/load-by-page`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getSpecialQueueCount (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/special-queue-list-count`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getSpecialQueueItem (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/special-queue-list`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getSpecialReview (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/get-payment-special-info`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  resolveSpecialReview (id, success, failure) {
    return ajax.post(
      `${BASE_URL}/resolve-special?id={0}`.format(id),
      null,
      success,
      failure,
      { showLoading: true }
    )
  },
  // region export paid off
  exportLoanQueue (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/work-queue/loan-queue-export`,
      input,
      success,
      failure
    )
  },
  searchExportLoanQueueItem (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/work-queue/list-by-loan-status`,
      input,
      success,
      failure
    )
  },
  searchExportLoanQueueCount (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/work-queue/loan-queue-count`,
      input,
      success,
      failure
    )
  },
  // endregion
  manuallyPaidOff (loanId, success, failure) {
    const formData = new FormData()
    formData.append('loanId', loanId)
    return ajax.post(
      `${BASE_URL}/manual-paid-off`,
      formData,
      success,
      failure
    )
  },
  closeMultipleLoan (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/close-multiple-loan`,
      input,
      success,
      failure
    )
  },
  getMaxPartialAmount (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/get-partially-make-up-info`,
      input,
      success,
      failure
    )
  },
  getPrincipalLimit (id, success, failure) {
    return ajax.get(
      `${BASE_URL}/get-principal-limit`,
      {
        id: id
      },
      success,
      failure
    )
  },
  checkLoanFlag (loanId, success, failure) {
    return ajax.get(
      `${BASE_URL}/check-loan-flag`,
      {
        loanId: loanId
      },
      success,
      failure,
      { showLoading: true }
    )
  },
  updateFlag (loanId, success, failure) {
    return ajax.get(
      `${BASE_URL}/update-flag`,
      {
        loanId: loanId
      },
      success,
      failure,
      { showLoading: true }
    )
  },
  judgeRevokeAch (loanId, success, failure) {
    return ajax.get(
      `${BASE_URL}/judge-revoke-ach`,
      {
        loanId: loanId
      },
      success,
      failure,
      { showLoading: true }
    )
  }
}
export { ProcessingApi }
